import { Reducer } from 'redux';
import { IStatusListUpdate } from './@types';
import {
  setProductToUpdate,
  setCategoryToUpdate,
  setProductWithInfosUpdated,
  setProductStockUpdated,
} from './duck';

import {
  EProductToUpdate,
  ECategoryToUpdate,
  EProductUpdatedInfos,
  EProductStockUpdated,
} from './actions';

const INITIAL_STATE: IStatusListUpdate = {
  productToUpdateStatus: {},
  categoryToUpdateStatus: {},
  productUpdatedInfos: {},
  productStockUpdated: {},
};

const reducer: Reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case EProductToUpdate.PRODUCT_UPDATED_STATUS:
      return setProductToUpdate(state, action.payload);
    case ECategoryToUpdate.CATEGORY_UPDATED_STATUS:
      return setCategoryToUpdate(state, action.payload);
    case EProductUpdatedInfos.PRODUCT_UPDATED_INFOS:
      return setProductWithInfosUpdated(state, action.payload);
    case EProductStockUpdated.PRODUCT_STOCK_UPDATED:
      return setProductStockUpdated(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
